module.exports = "/fonts/nucleo.ttf?b17a118e13e53558658b681a0ebdad82";